import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const quickUserV2Mutations: UpdatesConfig['Mutation'] = {
  quickUserDelete: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('quickUsers', cache);
  },
};

export default quickUserV2Mutations;
